(function () {
    // 获取设备类型信息
    function getClientInfo() {
        const ua = navigator.userAgent;
        if (/mobile/i.test(ua)) return "Mobile";
        if (/tablet/i.test(ua)) return "Tablet";
        return "PC";
    }

    // 获取UTM参数
    function getUTMParams() {
        const params = new URLSearchParams(window.location.search);
        return {
            utm_source: params.get('utm_source'),
            utm_medium: params.get('utm_medium'),
            utm_campaign: params.get('utm_campaign')
        };
    }

    // 获取访客IP地址
    async function getIPAddress() {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    }

    // 发送访问信息到 ga.acousart.com 服务器
    async function sendVisitorData() {
        const ip = await getIPAddress();
        const clientType = getClientInfo();
        const utmParams = getUTMParams();
        const visitorData = {
            referrer: document.referrer || "Direct",
            ip: ip,
            visitTime: new Date().toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }),
            clientType: clientType,
            utmParams: utmParams
        };

        // 发送访问信息到 ga.acousart.com 的 record.php 处理
        fetch('https://ga.acousart.com/record.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(visitorData)
        })
        .then(response => response.json())
        .then(data => console.log('Success:', data))
        .catch(error => console.error('Error:', error));
    }

    // 执行发送数据
    sendVisitorData();
})();
